import React from 'react';
//import { Outlet } from "react-router-dom";
import '../discography/discography.css';
//import { Link } from "react-router-dom";
//import Navbar from '../../components/navbar/navbar';
import Album from '../../components/album/album';
//import Footer from '../../components/footer/footer';

function Discography() {



    return (

        <>
            <Album />
        </>
    );

}

export default Discography;